<!--<div class="scrollbar">-->
    <app-detail-list-template [Editing]="true" [Inline]="true" [Data]="ListTemplateData$ | async"></app-detail-list-template>
<!--</div>-->
<ng-template #informationFormTemplate let-formControl="formControl">
    <app-arl-information-input [ARLType]="Form.controls.Type.value" [inputMode]="Form.value.Type === ARLTypeEnum.ResourceArl ? 'selectSearch' : 'autocomplete'" [informationControl]="formControl" (entitySelected)="onSetResourceId($event)"></app-arl-information-input>
</ng-template>
